import React, { useEffect, useState } from 'react';
import { sharedTableStyles } from '../../utils/tableStyles';
import { TableSkeleton } from '../../components/UI/Skeleton/Skeleton';
import RowActionMenu from '../../components/UI/RowActionMenu/RowActionMenu';
import TableCard from '../../components/UI/TableToolbar/TableCard';
import TableToolbar from '../../components/UI/TableToolbar/TableToolbar';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import _debounce from 'lodash/debounce';
import { useForm } from 'react-hook-form';
import DataTable from 'react-data-table-component';
import { yupResolver } from '@hookform/resolvers/yup';

import '../../App.css';
import './SupportTicket.scss';

import {
  useGetSupportTicketsQuery,
  useAddSupportTicketMutation,
  useEditSupportTicketMutation
} from '../../redux/apis/SupportTicketApi';
import { useIsLoggedInQuery } from '../../redux/apis/authApi';
import { useGetEmployeeDropDownQuery } from '../../redux/apis/employee';

import EmptyData from '../../components/UI/EmptyData';
import PageHeader from '../../components/common/PageHeader';
import { LeaveRequestData } from '../../components/Data/AppData';

import {
  LB_HEADER,
  LB_EMPLOYEE_TABLE_COLS,
  LB_EMPLOYEE_TABLE_COLS_SORT
} from '../../utils/constant/labels';

import { notification } from '../../utils/notification';
import { TOAST_TYPE } from '../../utils/constant/errorMessage';
import { BT_BUTTON_LABELS } from '../../utils/constant/buttons';
import { supportRequestSchema } from '../../utils/schemas/auth';
import { INPUT_LABEL, PLACEHOLDER } from '../../utils/constant/placeHolders';
import { ROLES, GLOBAL, LEAVE_STATUS } from '../../utils/constant/global';

import {
  skipRow,
  matchData,
  formatDate,
  paginationRow,
  getStatusBadge,
  getErrorMessage
} from '../../utils/handler';

const initialState = {
  isEditModalData: {},
  modalHeader: { title: '', isEdit: false },
  isEditModal: { status: false, id: '' },
  isView: { status: false },
  isDeleteModal: { status: false, id: '' },
  currentPage: 1,
  rowsPerPage: 10,
  isNext: false,
  leaveCount: 0,
  sortField: 'createdAt',
  sortDirection: false,
  loading: false,
  dropdownDataStore: [],
  currentPageDropdown: 1,
  rowsPerPageDropdown: 50,
  reason: '',
  reasonError: '',
  responseReason: '',
  responseReasonError: ''
};

const {
  LB_TBL_COL_ACTION,
  LB_TBL_COL_STATUS,
  LB_TBL_COL_REASON,
  LB_TBL_COL_REQUEST_DATE,
  LB_TBL_COL_EMPLOYEE_NAME,
  LB_TBL_COL_SUPPORT_RESPONSE_REASON
} = LB_EMPLOYEE_TABLE_COLS;

const {
  LB_SUPPORT_REJECT,
  LB_SUPPORT_APPROVE,
  LB_ASK_SUPPORT_REJECT,
  LB_ADD_SUPPORT_REQUEST,
  LB_ASK_SUPPORT_APPROVE,
  // LB_EDIT_SUPPORT_REQUEST,
  LB_SUPPORT_TICKET_REQUEST
} = LB_HEADER;

const { ADMIN, HR } = ROLES;
const { REJECTED, ACCEPTED } = LEAVE_STATUS;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { SR_EMPLOYEE_NAME } = LB_EMPLOYEE_TABLE_COLS_SORT;

// const { SUN, SAT } = VALIDATION_DAY;
const { DESC, ASC } = GLOBAL;
const { LB_SUPPORT_TICKET_REASON, LB_USER } = INPUT_LABEL;
const { PH_SUPPORT_TICKET_REASON } = PLACEHOLDER;
const { BTN_SAVE, BTN_ACCEPT, BTN_REJECT: REJECT_BTN, BTN_ADD_SUPPORT_TICKET } = BT_BUTTON_LABELS;

const supportTicketTableStyles = {
  ...sharedTableStyles,
  headCells: {
    style: {
      ...sharedTableStyles.headCells.style,
      color: '#334155',
      fontWeight: 700
    }
  },
  rows: {
    ...sharedTableStyles.rows,
    style: {
      ...sharedTableStyles.rows.style,
      color: '#6b7280'
    }
  },
  cells: {
    style: {
      ...sharedTableStyles.cells.style,
      color: '#6b7280',
      fontWeight: 600
    }
  }
};

const SupportTicket = () => {
  const [state, setState] = useState(initialState);
  const { data: isLogin } = useIsLoggedInQuery();

  const { data: dropdownData, refetch: employeeDropDownQuery } =
    isLogin?.data?.hrxRole?.roleName === 'Admin'
      ? useGetEmployeeDropDownQuery({
          skip: skipRow(state.currentPageDropdown, state.rowsPerPageDropdown),
          limit: state.rowsPerPageDropdown
        })
      : { data: null, isLoading: false, isFetching: false, refetch: () => {} };

  const {
    data,
    isLoading,
    isFetching,
    refetch: supportRequestRefetch
  } = useGetSupportTicketsQuery({
    search: state.search,
    skip: skipRow(state.currentPage, state.rowsPerPage),
    limit: state.rowsPerPage,
    sort: state.sortField,
    sortType: state.sortDirection ? DESC : ASC,
    userId: isLogin?.data?.hrxRole?.roleName === 'Admin' ? undefined : isLogin?.data?._id
  });

  const [addSupportTicket] = useAddSupportTicketMutation();
  const [EditSupportRequest] = useEditSupportTicketMutation();

  const handleChangeSort = (sortField) => {
    setState({ ...state, sortDirection: !state.sortDirection, sortField: sortField.sortField });
  };

  const defaultValue = {
    userId: '',
    dateOfRequest: '',
    requestReason: ''
  };

  const {
    reset,
    // watch,
    register,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(supportRequestSchema),
    values: state.isEditModalData?._id ? state.isEditModalData : defaultValue
  });

  // const valuesData = watch();
  // const startDate = new Date(valuesData.startDate);
  //const endDate = new Date(valuesData.endDate);

  const allowedRoles = [ADMIN, HR];
  const isAdminOrHr = allowedRoles.includes(isLogin.data?.hrxRole?.roleName);
  let columnT = '';
  columnT = [
    ...([ADMIN, HR].includes(isLogin.data?.hrxRole?.roleName)
      ? [
          {
            name: LB_TBL_COL_EMPLOYEE_NAME,
            sortField: SR_EMPLOYEE_NAME,
            selector: () => {},
            sortable: true,
            cell: (row) => (
              <div>
                <span className="support-ticket-name">{row?.user?.name || ''}</span>
              </div>
            )
          }
        ]
      : []),
    {
      name: LB_TBL_COL_REQUEST_DATE,
      selector: (row) => formatDate(row?.dateOfRequest, 'DD-MMM-YYYY hh:mm a'),
      sortable: false
    },
    {
      name: LB_TBL_COL_REASON,
      selector: (row) => row.requestReason || '-',
      sortable: false,
      cell: (row) => <div className="reason-cell">{row.requestReason || '-'}</div>
    },
    {
      name: LB_TBL_COL_SUPPORT_RESPONSE_REASON,
      selector: (row) => row.responseReason || '-',
      sortable: false,
      cell: (row) => <div className="reason-cell">{row.responseReason || '-'}</div>
    },
    {
      name: LB_TBL_COL_STATUS,
      selector: (row) => getStatusBadge(row, 'supportTicketStatus'),
      sortable: false
    }
  ];

  if (isAdminOrHr) {
    columnT.push({
      name: LB_TBL_COL_ACTION,
      selector: () => {},
      sortable: false,
      cell: (row) => (
        <RowActionMenu
          actions={[
            {
              label: 'Accept',
              icon: 'icofont-check-circled',
              variant: 'success',
              hidden: row.supportTicketStatus === ACCEPTED,
              onClick: () => {
                setState({ ...state, isEditModal: { status: true, id: row?._id } });
              }
            },
            {
              label: 'Reject',
              icon: 'icofont-close-circled',
              variant: 'danger',
              hidden: row.supportTicketStatus === REJECTED,
              onClick: () => {
                setState({ ...state, isDeleteModal: { status: true, id: row?._id } });
              }
            }
          ]}
        />
      )
    });
  }

  const handleAddSupportRequest = async (supportRequest) => {
    try {
      setState({ ...state, loading: true });
      const res = await addSupportTicket(supportRequest);
      if (res.data?.success) {
        setState({
          ...state,
          modalHeader: { title: '', isEdit: false },
          loading: false
        });
        supportRequestRefetch();
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
      } else {
        setState({
          ...state,
          modalHeader: { title: '', isEdit: false, loading: false }
        });
        notification(res?.error?.data?.statusMessage, TOAST_ERROR);
        setState({ ...state, loading: false, modalHeader: { title: '', isEdit: false } });
      }
      reset();
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  const handleEditSupportRequest = async (supportRequest, id) => {
    try {
      setState({ ...state, loading: true });
      const res = await EditSupportRequest({ data: supportRequest, id: id });
      if (res.data?.success) {
        setState({
          ...state,
          modalHeader: { title: '', isEdit: false },
          isDeleteModal: { status: false, id: '' },
          isEditModal: { status: false, id: '' },
          isEditModalData: {},
          loading: false,
          responseReason: '',
          reason: ''
        });
        supportRequestRefetch();
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
      } else {
        setState({
          ...state,
          modalHeader: { title: '', isEdit: false },
          isDeleteModal: { status: false, id: '' },
          isEditModal: { status: false, id: '' },
          isEditModalData: {},
          loading: false,
          responseReason: '',
          reason: ''
        });
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  const handleStatusChange = (status, id, reason) => {
    handleEditSupportRequest(
      {
        supportTicketStatus: status,
        responseReason: reason
      },
      id
    );
  };

  const handleAccept = () => {
    if (!state.reason) {
      setState({ ...state, reasonError: 'Reason is required' });
      return;
    }
    if (state.reason.length > 500) {
      setState({ ...state, reasonError: 'Reason must be less than 500 characters' });
      return;
    }
    handleStatusChange(ACCEPTED, state?.isEditModal.id, state.reason);
  };

  const handleReject = () => {
    if (!state.responseReason) {
      setState({ ...state, responseReasonError: 'Reason is required' });
      return;
    }
    if (state.responseReason.length > 140) {
      setState({ ...state, responseReasonError: 'Reason must be less than 140 characters' });
      return;
    }
    handleStatusChange(REJECTED, state?.isDeleteModal.id, state.responseReason);
  };

  const onSubmit = (data) => {
    const userId = data.userId || (isLogin && isLogin.data && isLogin.data._id);
    const supportRequest = {
      ...data,
      dateOfRequest: state?.isEditModalData?._id
        ? state?.isEditModalData.dateOfRequest
        : new Date().getTime(),
      userId: userId
    };

    if (state?.isEditModalData?._id) {
      const defaultValues = state?.isEditModalData;
      const updatedValues = matchData(supportRequest, defaultValues);
      handleEditSupportRequest(updatedValues, state?.isEditModalData?._id);
    } else {
      handleAddSupportRequest(supportRequest);
    }
  };

  useEffect(() => {
    supportRequestRefetch();
    setState({ ...state, isNext: data?.isNext });
  }, [state.rowsPerPage, state.currentPage, state.search, state.sortDirection]);

  const handleChangePage = (page) => {
    setState({ ...state, currentPage: page });
  };

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    setState({ ...state, rowsPerPage: newRowsPerPage, currentPage: 1 });
  };

  const debouncedOnSearchData = _debounce((data) => {
    setState({ ...state, search: data });
  }, 300);

  const handleMenuScrollToBottom = async () => {
    if (dropdownData.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDropdown: prevState.currentPageDropdown + 1
      }));
      employeeDropDownQuery();
    }
  };

  useEffect(() => {
    if (dropdownData && Array.isArray(dropdownData.data)) {
      setState((prevState) => ({
        ...prevState,
        dropdownDataStore: [...prevState.dropdownDataStore, ...dropdownData.data]
      }));
    }
  }, [dropdownData]);

  return (
    <div className="container-xxl">
      <PageHeader headerTitle={LB_SUPPORT_TICKET_REQUEST} />
      <div className="row clearfix g-3">
        <div className="col-sm-12">
          <TableCard>
            <TableToolbar
              onSearch={debouncedOnSearchData}
              actions={
                <button
                  type="button"
                  className="app-table-toolbar__add-btn"
                  onClick={() => {
                    setState({
                      ...state,
                      modalHeader: { title: LB_ADD_SUPPORT_REQUEST, isEdit: true },
                      isEditModalData: {}
                    });
                  }}
                >
                  <i className="icofont-plus-circle"></i>
                  {BTN_ADD_SUPPORT_TICKET}
                </button>
              }
            />
            <div className="card-body">
              <div className="support-ticket-table">
                <DataTable
                  customStyles={supportTicketTableStyles}
                  title={LeaveRequestData.title}
                  columns={columnT}
                  data={data?.data || []}
                  defaultSortField="title"
                  pagination
                  paginationServer
                  onSort={handleChangeSort}
                  sortField={state.sortField}
                  sortDirection={state.sortDirection}
                  paginationTotalRows={paginationRow(
                    // state.isNext,
                    data?.isNext,
                    state.rowsPerPage,
                    state.currentPage,
                    data?.data?.length
                  )}
                  paginationPerPage={state.rowsPerPage}
                  paginationRowsPerPageOptions={[5, 10, 20, 30]}
                  paginationComponentOptions={{
                    noRowsPerPage: false,
                    rangeSeparatorText: 'of',
                    selectAllRowsItem: state.isNext,
                    selectAllRowsItemText: 'All',
                    paginationButtonsDisabled: state.isNext
                  }}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  selectableRows={false}
                  noDataComponent={<EmptyData />}
                  className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                  highlightOnHover={true}
                  progressPending={isLoading || isFetching ? true : false}
                  progressComponent={<TableSkeleton columns={6} />}
                />
              </div>
            </div>
          </TableCard>
        </div>
      </div>
      <Modal
        centered
        className="support-request-modal"
        dialogClassName="support-request-modal__dialog"
        contentClassName="support-request-modal__content"
        show={state.modalHeader.isEdit}
        onHide={() => {
          setState({ ...state, modalHeader: { title: '', isEdit: false } });
        }}
      >
        <Modal.Header className="support-request-modal__header">
          <div className="support-request-modal__header-content">
            <span className="support-request-modal__header-icon" aria-hidden="true">
              <i className="icofont-live-support" />
            </span>
            <div className="support-request-modal__header-copy">
              <Modal.Title className="fw-bold support-request-modal__title">
                {state.modalHeader.title}
              </Modal.Title>
              <p className="support-request-modal__subtitle">
                Describe the issue so the team can follow up
              </p>
            </div>
          </div>
          <button
            type="button"
            className="btn-close support-request-modal__close"
            aria-label="Close"
            onClick={() => {
              reset();
              setState({ ...state, modalHeader: { title: '', isEdit: false } });
            }}
          />
        </Modal.Header>
        <Modal.Body className="support-request-modal__body">
          <div className="deadline-form support-request-modal__card">
            <form className="support-request-modal__form" onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-sm-6">
                  {[ADMIN, HR].includes(isLogin?.data?.hrxRole?.roleName) && (
                    <div className="mb-3 support-request-modal__field">
                      <label className="form-label support-request-modal__label">{LB_USER}</label>
                      <Select
                        className="support-request-modal__select"
                        classNamePrefix="support-request-select"
                        options={state.dropdownDataStore?.map((val) => ({
                          value: val._id,
                          label: val.name
                        }))}
                        onChange={(selectedOption) => {
                          setValue('userId', selectedOption.value);
                        }}
                        defaultValue={{
                          value: isLogin.data?._id || state?.isEditModalData?.user?._id,
                          label: isLogin.data?.name || state?.isEditModalData?.user?.name
                        }}
                        onMenuScrollToBottom={handleMenuScrollToBottom}
                        placeholder="Select option..."
                        isDisabled={state.isEditModalData?.user?._id}
                      />
                      <small className="text-danger support-request-modal__error">
                        {getErrorMessage('userId', errors)}
                      </small>
                    </div>
                  )}
                </div>
              </div>
              <div className="row g-3 mb-3">
                <div className="mb-1 support-request-modal__field">
                  <label
                    htmlFor="exampleFormControlTextarea78d"
                    className="form-label support-request-modal__label"
                  >
                    {LB_SUPPORT_TICKET_REASON}
                  </label>
                  <textarea
                    className="form-control support-request-modal__textarea"
                    placeholder={PH_SUPPORT_TICKET_REASON}
                    {...register('requestReason')}
                    id="exampleFormControlTextarea78d"
                    rows="3"
                  ></textarea>
                  <small className="text-danger support-request-modal__error">
                    {getErrorMessage('requestReason', errors)}
                  </small>
                  <p className="support-request-modal__hint">
                    Include what happened and what you need help with.
                  </p>
                </div>
              </div>
              <Modal.Footer className="support-request-modal__footer">
                <button
                  type="submit"
                  disabled={state.loading}
                  className="btn support-request-modal__submit"
                >
                  {state.loading ? (
                    <div className="spinner-border spinner-border-sm" role="status"></div>
                  ) : (
                    <>
                      <i className="icofont-check-circled" aria-hidden="true" />
                      {BTN_SAVE}
                    </>
                  )}
                </button>
              </Modal.Footer>
            </form>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        centered
        show={state?.isEditModal.status}
        onHide={() => {
          setState({
            ...state,
            reason: '', // Clear the reason
            reasonError: '', // Clear any error message
            isEditModal: { status: false, id: '' } // Reset modal state
          });
        }}
      >
        <Modal.Header closeButton>
          <h5 className="modal-title fw-bold" id="dremovetaskLabel">
            {LB_SUPPORT_APPROVE}
          </h5>
        </Modal.Header>
        <Modal.Body className="justify-content-center flex-column d-flex">
          <i className="icofont-simple-smile text-success display-2 text-center mt-2"></i>
          <p className="mt-4 fs-5 text-center">{LB_ASK_SUPPORT_APPROVE}</p>
          <div className="mb-3">
            <textarea
              rows={4}
              maxLength={140}
              className={`form-control mb-3 ${state.reasonError && 'is-invalid'}`}
              placeholder="Enter reason"
              value={state.reason}
              onChange={(e) =>
                setState({
                  ...state,
                  reason: e.target.value,
                  reasonError: '' // Clear the error on input change
                })
              }
            />
            {state.reasonError && <div className="invalid-feedback">{state.reasonError}</div>}
          </div>

          <button className="btn btn-success text-white" onClick={handleAccept}>
            {BTN_ACCEPT}
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        centered
        show={state?.isDeleteModal.status}
        onHide={() => {
          setState({
            ...state,
            responseReason: '', // Clear the reason
            responseReasonError: '', // Clear any error message
            isDeleteModal: { status: false, id: '' } // Reset modal state
          });
        }}
      >
        <Modal.Header closeButton>
          <h5 className="modal-title fw-bold" id="leaverejectLabel">
            {LB_SUPPORT_REJECT}
          </h5>
        </Modal.Header>
        <Modal.Body className="justify-content-center flex-column d-flex">
          <i className="icofont-sad text-danger display-2 text-center mt-2"></i>
          <p className="mt-4 fs-5 text-center">{LB_ASK_SUPPORT_REJECT}</p>
          <div className="mb-3">
            <textarea
              rows={4}
              maxLength={140}
              className={`form-control mb-3 ${state.responseReasonError && 'is-invalid'}`}
              placeholder="Enter reason"
              value={state.responseReason}
              onChange={(e) =>
                setState({
                  ...state,
                  responseReason: e.target.value,
                  responseReasonError: '' // Clear the error on input change
                })
              }
            />
            {state.responseReasonError && (
              <div className="invalid-feedback">{state.responseReasonError}</div>
            )}
          </div>
          <button className="btn btn-danger text-white" onClick={handleReject}>
            {REJECT_BTN}
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SupportTicket;
